import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs } from "../../app/layout/Tabs";

/** Acquisition and placement of the same artifact: the walk that produces a SLAM
 *  map, and the transform that puts it in the warehouse frame. Two sub-tabs
 *  rather than one scroll, because each is a full working surface. */
export function MapTab() {
  const { t } = useTranslation();
  return (
    <Tabs
      ariaLabel={t("warehouse.map.aria")}
      items={[
        { to: "capture", label: t("warehouse.map.capture") },
        { to: "align", label: t("warehouse.map.align") },
      ]}
    >
      <Outlet />
    </Tabs>
  );
}
